import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRenaultComponent } from './simple-icons-renault.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRenaultComponent ],
    exports:      [ SimpleIconsRenaultComponent ],
    bootstrap:    []
})
export class SimpleIconsRenaultModule {}
